import { intl } from '@fullstory/intl';
import { Device } from '@fullstory/proto/fs/api/segment';
import { Icon } from '@fullstory/components';

export type LabelIcon = {
  label: string;
  icon: React.ComponentProps<typeof Icon>['name'];
};

export const deviceToLabel: { [key in Device]?: LabelIcon } = {
  [Device.DEVICE_INVALID]: {
    label: intl.formatMessage({ defaultMessage: 'Unknown', id: '5jeq8P' }),
    icon: 'unknown-device',
  },
  [Device.DEVICE_MOBILE]: {
    label: intl.formatMessage({ defaultMessage: 'Mobile', id: 'GWtmtu' }),
    icon: 'phone',
  },
  [Device.DEVICE_TABLET]: {
    label: intl.formatMessage({ defaultMessage: 'Tablet', id: '/bfzrI' }),
    icon: 'tablet',
  },
  [Device.DEVICE_DESKTOP]: {
    label: intl.formatMessage({ defaultMessage: 'Desktop', id: 'tHSb8p' }),
    icon: 'desktop',
  },
};

export const deviceStringToIcon = (device: string): React.ComponentProps<typeof Icon>['name'] => {
  switch (device) {
    case 'Desktop':
      return 'desktop';
    case 'Mobile':
      return 'phone';
    case 'Tablet':
      return 'tablet';
    default:
      return 'unknown-device';
  }
};
